export const JUSTIFICATIVA_MAX = 500;
export const JUSTIFICATIVA_LABEL = "Justificativa";
export const JUSTIFICATIVA_OBRIGATORIA = "Preencha a justificativa para continuar.";
